import ImportHealthStatusManagementTable from '@/components/tables/health-status-management/import-health-status-by-list.table';
import ImportRecommendFoodManagementTable from '@/components/tables/health-status-management/import-recommend-food-by-list.table';
import ListHealthStatusTable from '@/components/tables/health-status-management/list-health-status.table';
import RecommendFoodManagementTable from '@/components/tables/health-status-management/recommend-food-management.table';
import { css } from '@emotion/react';
import { Row, Tabs, Typography } from 'antd';
import { useState } from 'react';

export default function HealthStatusManagement() {
  const [activeTab, setActiveTab] = useState('LIST');

  const items = [
    { key: 'LIST', label: 'Danh sách tình trạng sức khỏe' },
    { key: 'MANAGE', label: 'Quản lý thực phẩm khuyến nghị theo tình trạng sức khỏe' },
  ];

  return (
    <div css={rootStyles}>
      {['LIST', 'MANAGE'].includes(activeTab) && (
        <>
          <Row css={boxStyles} justify="space-between" align="middle">
            <Typography.Title css={titleStyles} level={5}>
              Quản lý tình trạng sức khỏe
            </Typography.Title>
          </Row>

          <Tabs
            css={tabStyle}
            activeKey={activeTab}
            onChange={(key) => setActiveTab(key)}
          >
            {items.map((item) => (
              <Tabs.TabPane tab={item.label} key={item.key} />
            ))}
          </Tabs>
        </>
      )}

      <div css={contentStyles}>
        {activeTab === 'LIST' && <ListHealthStatusTable setActiveTabProps={setActiveTab} />}
        {activeTab === 'MANAGE' && <RecommendFoodManagementTable setActiveTabProps={setActiveTab} />}
        {activeTab === 'IMPORT_HS_BY_LIST' && <ImportHealthStatusManagementTable setActiveTabProps={setActiveTab} />}
        {activeTab === 'IMPORT_RCM_FOOD_BY_LIST' && <ImportRecommendFoodManagementTable setActiveTabProps={setActiveTab} />}
      </div>
    </div>
  );
}

const rootStyles = css`
  background: var(--gray-soft-color);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.4rem 2.4rem;
  min-height: calc(100vh - var(--header-height));
`;

const boxStyles = css`
  padding: 1rem;
  background: var(--white-color);
  border-radius: 1rem;
  box-shadow: 0.02rem 0.04rem 0.2rem var(--gray-light-color);
  &:nth-of-type(2) {
    padding: 1.6rem 1rem;
  }
`;

const titleStyles = css`
  margin-bottom: 0 !important;
  line-height: 3.2rem !important;
`;

const tabStyle = css`
  .ant-tabs-nav {
    margin-bottom: 0;
  }

  .ant-tabs-tab {
    padding: 6px 8px;
    color: #333;
    border: 1px solid #ccc;
    background-color: #f0f0f0;
  }

  .ant-tabs-tab:not(:first-of-type) {
    margin: 0 0 0 8px !important;
  }

  .ant-tabs-tab-active {
    background-color: var(--blue-dark-color);
    border: 1px solid var(--blue-dark-color);
    .ant-tabs-tab-btn {
      color: #ffffff !important;
    }
  }

  .ant-tabs-ink-bar {
    display: none;
  }

  .ant-tabs-tab:hover {
    color: #333 !important;
  }
`;

const contentStyles = css`
  flex: 1;
  display: flex;
  flex-direction: column;
`;